export default "__VITE_ASSET__DOlsDs$q__"